<script>
import {
  newsLettersSelectorEmits,
  newsLettersSelectorProps,
  useNewsLetterSelector
} from "./mixin";

import Button from "@/components/atoms/button";
import Form from "@/components/molecules/form";
import Icon from "@/components/atoms/icon";
import ButtonIcon from "@/components/molecules/button-icon";
import FormSelect from "@/components/molecules/form-select";
import FormSelectOption from "@/components/molecules/form-select/form-select-option";
import StateOverlay from "@/components/molecules/state-overlay";
import Alert from "@/components/molecules/alert";

export default {
  name: "NewsletterSelector",
  components: {
    Form,
    Icon,
    Button,
    ButtonIcon,
    FormSelect,
    FormSelectOption,
    StateOverlay,
    Alert
  },
  props: { ...newsLettersSelectorProps() },
  emits: [...newsLettersSelectorEmits()],
  setup(props, context) {
    const {
      v$,
      isSuccess,
      isLoadingComputed,
      selectedMines,
      selectedProposals,
      newsLetters,
      proposed,
      save,
      addToNewsletters,
      removeFromNewsletters,
      init
    } = useNewsLetterSelector(props, context);

    onMounted(() => {
      init();
    });
    return {
      v$,
      isSuccess,
      isLoadingComputed,
      selectedMines,
      selectedProposals,
      newsLetters,
      proposed,
      addToNewsletters,
      removeFromNewsletters,
      save,
      init
    };
  }
};
</script>

<template>
  <Form
    :error="error"
    @submit.prevent="save()"
  >
    <StateOverlay
      :is-loading="isLoadingComputed"
      overlay
    >
      <div class="u-flex">
        <div class="u-flex-item-fluid">
          <label for="lettresMagasins">
            <h3 class="c-newsletter-selector--select-title u-text-center u-pt-xs u-pb-xs">
              Lettres d’informations proposées
            </h3>
          </label>
          <FormSelect
            id="lettresMagasins"
            v-model="selectedProposals"
            multiple
            class="u-flex u-flex-justify-center"
          >
            <FormSelectOption
              v-for="magasin in proposed"
              :key="magasin.id"
              :value="magasin.id"
            >
              {{ magasin.cp }} - Magasin {{ magasin.name }}
            </FormSelectOption>
          </FormSelect>
        </div>
        <div class="u-flex u-flex-column u-flex-justify-center u-pl-sm u-pr-sm">
          <ButtonIcon
            variant="primary"
            radius="full"
            icon-color="white"
            icon-name="chevron-right"
            class="u-mb-sm"
            @click="addToNewsletters"
          />
          <ButtonIcon
            variant="primary"
            radius="full"
            icon-color="white"
            icon-name="chevron-left"
            @click="removeFromNewsletters"
          />
        </div>
        <div class="u-flex-item-fluid">
          <label for="mesLettresMagasins">
            <h3 class="c-newsletter-selector--select-title u-text-center u-pt-xs u-pb-xs">
              Mes lettres d’informations
            </h3>
          </label>
          <FormSelect
            id="mesLettresMagasins"
            v-model="selectedMines"
            multiple
            class="u-flex u-flex-justify-center"
          >
            <FormSelectOption
              v-for="magasin in newsLetters"
              :key="magasin.id"
              :value="magasin.id"
            >
              {{ magasin.cp }} - Magasin {{ magasin.name }}
            </FormSelectOption>
          </FormSelect>
        </div>
      </div>
      <p
        v-if="isSuccess"
        class="u-text-center u-color-success u-mt-sm u-flex u-flex-justify-center u-flex-align-center"
      >
        <Icon
          name="check"
          size="md"
          variant="success"
        />
        <span class="u-ml-sm">Vos préférences de newsletters ont bien été enregistrées</span>
      </p>
      <div class="u-mt-sm u-text-center">
        <Button
          variant="primary"
          radius="full"
          size="md"
          type="submit"
          value="Mettre à jour mes newsletters"
        />
      </div>
      <div id="newsletter_infos">
        <Alert
          has-icon
          icon-position="left"
          icon-name="info-circle"
          icon-size="lg"
          icon-color="primary-light"
          radius="md"
          class="u-mt-sm"
        >
          <h3 class="u-mb-sm">
            Pour choisir vos lettres d'information, c'est simple !
          </h3>
          <div class="u-flex u-flex-align-center u-mb-sm">
            <ButtonIcon
              variant="primary"
              radius="full"
              icon-color="white"
              icon-name="chevron-right"
              class="u-mr-sm"
            />
            <div class="u-flex-item-fluid">
              <p>Pour vous abonner à une lettre d'information, sélectionnez la lettre dans la colonne de gauche intitulée "Lettres d'informations proposées" et cliquez sur la flèche.</p>
              <p>La lettre est alors ajoutée dans la colonne de droite intitulée "Mes lettres d'informations".</p>
            </div>
          </div>
          <div class="u-flex u-flex-align-center">
            <ButtonIcon
              variant="primary"
              radius="full"
              icon-color="white"
              icon-name="chevron-left"
              class="u-mr-sm"
            />
            <div class="u-flex-item-fluid">
              <p>Pour vous désabonner d'une lettre d'information, sélectionnez la lettre dans la colonne de droite intitulée "Mes lettres d'informations" et cliquez sur la flèche.</p>
              <p>N'oubliez pas d'enregistrer vos modifications en cliquant sur le bouton Enregistrer les modifications.</p>
            </div>
          </div>
        </Alert>
      </div>
    </StateOverlay>
  </Form>
</template>

<style lang="scss" scoped>
.c-newsletter-selector--select-title {
  margin: auto;
  background-color: color(primary);
  color: #fff;
  border-radius: radius(sm) radius(sm) 0 0;
}
</style>
